// Tiny fetch wrapper. Auto-attaches X-Admin-Key when the user is signed in,
// throws on non-2xx with the server-side error message.

import { getKey } from "./adminStore";

function authHeaders(): HeadersInit {
  const key = getKey();
  return key ? { "X-Admin-Key": key } : {};
}

async function check(res: Response): Promise<Response> {
  if (res.ok) return res;
  let msg = `HTTP ${res.status}`;
  try {
    const data = await res.clone().json();
    if (data && typeof data === "object" && "error" in data && typeof data.error === "string") {
      msg = data.error;
    }
  } catch {
    /* non-json error body */
  }
  const e = new Error(msg);
  (e as any).status = res.status;
  throw e;
}

export async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { headers: { ...authHeaders() } });
  await check(res);
  return (await res.json()) as T;
}

export async function authCheck(key: string): Promise<boolean> {
  const res = await fetch("/api/auth-check", {
    headers: { "X-Admin-Key": key },
  });
  return res.ok;
}

export async function putSop(slug: string, markdown: string): Promise<void> {
  const res = await fetch(`/api/sop/${encodeURIComponent(slug)}`, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ markdown }),
  });
  await check(res);
}

export async function deleteSop(slug: string): Promise<void> {
  const res = await fetch(`/api/sop/${encodeURIComponent(slug)}`, {
    method: "DELETE",
    headers: { ...authHeaders() },
  });
  await check(res);
}

export interface ContentResponse {
  overrides: Record<string, string>;
}

export async function fetchContent(): Promise<ContentResponse> {
  return getJson<ContentResponse>("/api/content");
}
